import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider, useLanguage } from "./context/LanguageContext";
import LandingPage from "./pages/LandingPage";
import LegalNoticePage from "./pages/LegalNoticePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CookiesPolicyPage from "./pages/CookiesPolicyPage";
import AdminPage from "./pages/AdminPage";
import CustomPageView from "./pages/CustomPageView";
import ReservaStarlinkMiniPage from "./pages/ReservaStarlinkMiniPage";
import StarlinkCheckoutPage from "./pages/StarlinkCheckoutPage";
import StarlinkExitoPage from "./pages/StarlinkExitoPage";
import StarlinkSaldoOkPage from "./pages/StarlinkSaldoOkPage";
import StarlinkUserTracking from "./pages/StarlinkUserTracking";
import AdminStarlinkReservations from "./pages/AdminStarlinkReservations";
import CRMLogin from "./pages/crm/CRMLogin";
import CRMApp from "./pages/crm/CRMApp";
import CookieBanner from "./components/CookieBanner";
import TikTokPixel from "./components/TikTokPixel";
import { Toaster } from "./components/ui/sonner";
import { STARLINK_ENABLED } from "./lib/features";

function AppContent() {
  const { language } = useLanguage();
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/legal" element={<LegalNoticePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/cookies" element={<CookiesPolicyPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/crm/login" element={<CRMLogin />} />
        <Route path="/crm/*" element={<CRMApp />} />
        {STARLINK_ENABLED && (
          <>
            <Route path="/admin/reservas" element={<AdminStarlinkReservations />} />
            <Route path="/reserva-starlink-mini" element={<ReservaStarlinkMiniPage />} />
            <Route path="/reserva-starlink-mini/checkout" element={<StarlinkCheckoutPage />} />
            <Route path="/reserva-starlink-mini/exito" element={<StarlinkExitoPage />} />
            <Route path="/reserva-starlink-mini/saldo-ok" element={<StarlinkSaldoOkPage />} />
            <Route path="/mi-reserva" element={<StarlinkUserTracking />} />
          </>
        )}
        <Route path="/page/:slug" element={<CustomPageView />} />
      </Routes>
      <CookieBanner language={language} />
      <TikTokPixel />
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
